import(/* webpackMode: "eager" */ "/tmp/8de4e0fe59a5142/app/[locale]/error.tsx");
